import {inject, observer} from 'mobx-react';
import './index.scss';
import {receiveSuccessBtn, receiveBtn} from '../../config';
import {smartJump} from 'utils/utils';

@inject(({store}) => ({
    receive: store.receive,
    vouchers: store.vouchers,
    hasReceived: store.hasReceived
}))
@observer class Voucher extends React.Component {
    receive() {
        const {hasReceived, receive} = this.props;
        if (!hasReceived) {
            sendSK('click_dianpulianmeng');
            receive();
            return;
        }
        smartJump('/pg/zt/shucu/brand');
    }

    render() {
        const {vouchers, hasReceived} = this.props;
        return (
            <div className="m-voucher">
                <div className="m-voucher-wrap">
                    <div className="bg">
                        <div className="list">
                            {
                                vouchers.map(item => {
                                    const {productUseType, reduceAmount, desc} = item;

                                    return (
                                        <div className="item">
                                            <div className="supplier">{!productUseType ? '全部' : '部分'}店铺通用</div>
                                            <div className="reduce">
                                                <i className="ico">￥</i>
                                                {reduceAmount}
                                            </div>
                                            <div className="desc">
                                                {desc}
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="receive-btn" onClick={()=> {
                        this.receive();
                        sendSK('click_dianpulianmeng');
                    }}>
                        <img src={hasReceived ? receiveSuccessBtn : receiveBtn} alt=""/>
                    </div>
                </div>
                <div className="line">
                    <img src="//s.qunarzz.com/vacation_tuan/2020/06_shuchu/z-line_v2.png" alt=""/>
                </div>
            </div>
        );
    }
}

export default Voucher;